/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable class-methods-use-this */
// eslint-disable-next-line class-methods-use-this

import React from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { TOI_IMAGE_DOMAIN } from '../../../../../constants';

class VideoPlayer extends React.Component {
  constructor() {
    super();
    this.state = {
      videoDocked: false,
      //playState: false,
    };
    this.videoEventListener = this.videoEventListener.bind(this);
    this.closeDock = false;
    this.sendGa = true;
    this.userDataRef = React.createRef();
  }

  componentDidMount() {
    if (typeof document !== 'undefined') {
      this.throttledOnScroll = throttle(this.handleOnScroll, 100);
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.throttledOnScroll);
      window.addEventListener(
        'PLAYERVIDEOEND',
        () => {
          this.videoEventListener('', ['', 'VIDEOEND']);
        },
        false,
      );
      window.addEventListener(
        'PLAYERVIDEONEXT',
        event => {
          this.videoEventListener('', [
            '',
            'VIDEONEXT',
            event && event.detail ? event.detail : '',
          ]);
        },

        false,
      );
      window.addEventListener(
        '10_SEC_COMPLETED',
        () => {
          this.videoEventListener('', ['', '10_SEC_COMPLETED']);
        },
        false,
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userData?.isLoggedIn !== this.props.userData?.isLoggedIn) {
      this.userDataRef.current = this.props.userData;
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.throttledOnScroll);
    }
  }

  getMsidFromProps() {
    const { videoParams, routeParams } = this.props;
    const msid = videoParams ? videoParams.id : routeParams.msid;
    return msid;
  }
  videoEventListener = (messageName, data) => {
    this.a = '';
    const videoEvent = data ? data[1] : '';
    const eventData = Array.isArray(data) && data[2] ? data[2] : '';
    let newMsid = '';
    const { nextVideoMsidArray } = this.props;
    const currentMsid = this.state.activeMsid || this.getMsidFromProps();
    switch (videoEvent) {
      case 'VIDEOEND':
        if (
          nextVideoMsidArray &&
          Array.isArray(nextVideoMsidArray) &&
          nextVideoMsidArray.length > 0
        ) {
          newMsid =
            nextVideoMsidArray[nextVideoMsidArray.indexOf(currentMsid) + 1];
          if (this.state.activeMsid !== newMsid) {
            this.setState({
              activeMsid: newMsid,
            });
          }
          this.props.updateRHSVideoHighlightedIndex(newMsid);
        }
        break;
      case 'VIDEONEXT':
        if (
          eventData &&
          eventData.curVideoid &&
          nextVideoMsidArray &&
          Array.isArray(nextVideoMsidArray) &&
          nextVideoMsidArray.length > 0
        ) {
          newMsid = eventData.curVideoid;
          if (this.state.activeMsid !== newMsid) {
            this.setState({
              activeMsid: newMsid,
            });
          }
          this.props.updateRHSVideoHighlightedIndex(newMsid);
        }
        break;
      case '10_SEC_COMPLETED':
        if (
          this.userDataRef.current &&
          this.userDataRef.current.isLoggedIn &&
          this.props.earnPoints &&
          typeof this.props.earnPoints === 'function'
        ) {
          this.props.earnPoints({
            msid: this.getMsidFromProps(),
            actType: 'VIDEO_SHOW',
            ssoid: this.userDataRef.current.getUid(),
            phoneNumber: this.userDataRef.current.getMobile()?.Verified?.mobile,
            email: this.userDataRef.current.userData?.getEmail(),
          });
        }
        break;
      default:
      // console.log('messageName');
    }
  };
  static getMsidArrayFromVideolisting(videoListdata) {
    if (videoListdata instanceof Array) {
      return videoListdata.filter(item => item.hl).map(item => item.msid);
    }
    return [];
  }
  handleOnScroll = () => {
    const videoPlayer = document.querySelector('.video_slot');
    // const player = document.querySelector('.__player');
    // const player1 = document.querySelector('.__player1');
    // const lband = player1 ? player1.hasAttribute('data-lband-rendered') : '';
    if (
      videoPlayer &&
      videoPlayer.getBoundingClientRect() &&
      videoPlayer.getBoundingClientRect().y &&
      videoPlayer.getBoundingClientRect().height &&
      videoPlayer.getBoundingClientRect().y < 0 &&
      Math.abs(videoPlayer.getBoundingClientRect().y) >=
        videoPlayer.getBoundingClientRect().height * 0.3 &&
      !this.closeDock
    ) {
      this.setState({ videoDocked: true }, () => {
        const vdoowrapperclearfix = document.querySelector(
          '.vdoowrapperclearfix',
        );
        if (vdoowrapperclearfix) vdoowrapperclearfix.style.transform = `none`;

        if (this.sendGa && typeof window !== 'undefined') {
          this.sendGa = false;
        }
        // if (lband) {
        //   if (player1) {
        //     player1.style.display = 'none';
        //   }
        //   if (player) {
        //     player.style.minWidth = '100%';
        //     player.style.minHeight = '100%';
        //     player.style.left = '0px';
        //   }
        // }
      });
    } else
      this.setState({ videoDocked: false }, () => {
        const atfMobileObj = document.querySelector('.ATF_mobile_ads');
        if (atfMobileObj && typeof ResizeObserver !== 'undefined') {
          this.observeResizeChange(atfMobileObj);
        }
        // if (lband) {
        //   if (player1) {
        //     player1.style.display = '';
        //   }
        //   if (player) {
        //     player.style.minWidth = '';
        //     player.style.minHeight = '';
        //     player.style.left = '120px';
        //   }
        // }
      });
  };

  closeDockedVideo = () => {
    this.closeDock = true;
    this.setState({ videoDocked: false }, () => {
      // const player = document.querySelector('.__player');
      // const player1 = document.querySelector('.__player1');
      // const lband = player1 ? player1.hasAttribute('data-lband-rendered') : '';
      // if (lband) {
      //   if (player1) {
      //     player1.style.display = '';
      //   }
      //   if (player) {
      //     player.style.minWidth = '';
      //     player.style.minHeight = '';
      //     player.style.left = '120px';
      //   }
      // }
      if (
        typeof window !== 'undefined' &&
        window.player &&
        typeof window.player.pause !== 'undefined'
      )
        window.player.pause();
      sendGaThroughProps({
        data: {
          gaCategory: `${`VideoPlayer_Web_TOI`}`,
          gaAction: `ClosePIP_VideoPlayerMain`,
          gaLabel: `${
            window.location && window.location.href ? window.location.href : ''
          }`,
        },
      });
    });
  };

  render() {
    const { sectionadsCode, videoParams, s, width } = this.props;
    const { imgsize } = videoParams;
    const msid = this.getMsidFromProps(this.props);
    return (
      <>
        <div
          className={`${s.iframeWrapper} iframeWrapper ${
            this.state.videoDocked ? `fixedWrap` : ``
          }`}
        >
          {this.state.videoDocked && (
            <button
              type="button"
              className="closeDoc"
              onClick={() => this.closeDockedVideo()}
            />
          )}
          <div
            data-dev={`${!__PROD__}`}
            data-msid={msid}
            data-userinitiated="1"
            data-refreshed="0"
            data-source="videoshow"
            data-autoplay="1"
            data-adsection={
              sectionadsCode === '100501144' ? 'top-tennis-videos' : 'videos'
            }
            data-artdate={videoParams?.dl}
            data-seolocation={
              this.props.routeParams &&
              Array.isArray(this.props.routeParams) &&
              this.props.routeParams.length > 0
                ? this.props.routeParams[0]
                : ''
            }
            data-slikeid={videoParams?.eid}
            data-skipads={this.props.isPrime || this.props.skipAds ? 1 : 0}
            data-rmid="0"
            data-title={videoParams && videoParams.hl ? videoParams.hl : ''}
            data-nextVideoMsidArray={this.props.nextVideoMsidArray}
            data-secname={videoParams?.section}
            data-agency={videoParams?.source}
            data-bgimg={`${TOI_IMAGE_DOMAIN}/thumb/imgsize-${imgsize},msid-${msid},width-${width ||
              800},resizemode-4/${msid}.jpg`}
            data-description_url={videoParams?.wu}
            // data-nextVideoUrl={nextVideoUrl}
            data-isetimes={this.props.isEtimes ? 1 : 0}
            data-iswapview={0}
            data-campaign=""
            className="playerContainer"
            style={{
              height: this.state.videoDocked ? '180px' : '100%',
              width: '100%',
            }}
            id="toiPlayerContainer"
            dangerouslySetInnerHTML={{ __html: '' }}
            suppressHydrationWarning
            data-contenttype={videoParams?.contenttype}
            data-specialid={videoParams?.specialid}
          />
          {this.state.videoDocked && (
            <div className="vid_title">
              <strong>Now Playing</strong>
              <span>{videoParams?.hl}</span>
            </div>
          )}
        </div>
      </>
    );
  }
}

VideoPlayer.propTypes = {
  nextVideoMsidArray: PropTypes.arrayOf(PropTypes.string).isRequired,
  videoParams: PropTypes.shape({}).isRequired,
  sectionadsCode: PropTypes.number,
  s: PropTypes.objectOf({}),
  updateRHSVideoHighlightedIndex: PropTypes.func.isRequired,
  routeParams: PropTypes.shape({
    msid: PropTypes.string.isRequired,
  }).isRequired,
};

VideoPlayer.defaultProps = {
  sectionadsCode: '',
  s: {},
};

const mapStateToProps = state => ({
  videoParams: _get(state, 'videoshow.videoshowData.items[0]', {}),
  nextVideoMsidArray: state.videoshow?.videoshowData?.recommendedVideos
    ? VideoPlayer.getMsidArrayFromVideolisting(
        state.videoshow?.videoshowData?.recommendedVideos,
      )
    : [],
});

export default connect(mapStateToProps)(VideoPlayer);
